export let TOKEN =`JWT ${localStorage.getItem("dms-app-token")}`



export const startMessage ='正在启动流程'
export const returnMessage ='请选择退回节点'
export const commentMessage ='请填写退回理由'
export const notRunMessage ='此经销商此模式下尚有申请未完成，请在审批完成后在提交申请'
export const notMessage ='此经销商此模式下本年度已提交了授权及指标新建流程'

export const notDataMessage ='无法查询到指定数据，请检查'

export const noParentMessage ='该名称的母公司不存在'
export const confirmRPLMessage ='请确认RPL限制方名单'

export const mustConfirmContractMessage ='请勾选同意选择当前联系人'

export const missingDataMessage ='表单数据未填完整,请检查必填项'

export const errorMessage ='保存出错,请联系管理员'

export const noSelectMessage ='未经查询，不允许发起流程'

export const successMessage ='数据成功提交'




// WEBPACK FOOTER //
// ./src/api/services/common/const.js